module.exports = __webpack_public_path__ + "img/lanse.f74afbb6.png";